var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v(" 列表 "),_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.routerPush(item.id)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }